import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NbSelectModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { DozentFilterService, DozentTeamMember } from '../../services/dozent-filter.service';

@Component({
  selector: 'app-dozent-filter-dropdown',
  standalone: true,
  imports: [CommonModule, NbSelectModule, TranslateModule],
  styles: [`:host { display: contents; }`],
  template: `
    <nb-select
      *ngIf="(filter.isAdminView$ | async) && (filter.team$ | async)?.length"
      [selected]="filter.selected"
      (selectedChange)="onChange($event)"
      size="small"
      placeholder="{{ 'pages.dozent.filter.allDozents' | translate }}"
    >
      <nb-option [value]="null">
        {{ 'pages.dozent.filter.allDozents' | translate }}
      </nb-option>
      <nb-option *ngFor="let m of filter.team$ | async" [value]="m.id">
        {{ m.name }}
      </nb-option>
    </nb-select>
  `,
})
export class DozentFilterDropdownComponent implements OnInit {
  @Output() changed = new EventEmitter<string | null>();

  constructor(public filter: DozentFilterService) {}

  ngOnInit(): void {
    if (this.filter.team$.value.length === 0) {
      this.filter.loadTeam().subscribe();
    }
  }

  onChange(id: string | null) {
    this.filter.setSelected(id);
    this.changed.emit(id);
  }
}
